"use strict";
// STRAPI API SERVICE
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotelFacilityTypeEnum = void 0;
var HotelFacilityTypeEnum;
(function (HotelFacilityTypeEnum) {
    HotelFacilityTypeEnum["WELLNESS"] = "wellness";
    HotelFacilityTypeEnum["FOOD_AND_DRINK"] = "foodAndDrink";
    HotelFacilityTypeEnum["GENERAL"] = "general";
    HotelFacilityTypeEnum["SAFETY_AND_SECURITY"] = "safetyAndSecurity";
    HotelFacilityTypeEnum["SERVICES"] = "services";
})(HotelFacilityTypeEnum = exports.HotelFacilityTypeEnum || (exports.HotelFacilityTypeEnum = {}));
//# sourceMappingURL=hotels.js.map